// @flow

import React from 'react';
import GroupItem, {
  GroupItemContent,
  GroupItemTitle,
  GroupItemPrice,
  GroupItemText,
} from '../groupItem';

type Props = {
  title: string,
  type: string,
  alternativePriceString?: ?string,
  price?: ?number,
};

const ActiveItem = ({
  alternativePriceString, type, title, price, ...props
}: Props) => (
  <GroupItem {...props}>
    <GroupItemContent>
      {type
        && <GroupItemTitle>{type}</GroupItemTitle>}
      <GroupItemText type={type}>{title}</GroupItemText>
    </GroupItemContent>
    {
      alternativePriceString || (
        price !== null && <GroupItemPrice displayZeroes amount={price} />
      )
    }
  </GroupItem>
);

ActiveItem.defaultProps = {
  alternativePriceString: '',
  price: null,
};

export default ActiveItem;
